import paper from 'paper';			//eslint-disable-line no-unused-vars
//import * as PIXI from 'pixi.js';	//eslint-disable-line no-unused-vars
import 'pixi-spine';
//import 'pixi-particles';

//import 'babel-polyfill';

import jquery from 'jquery';

import '../libs/p3.min';

import Main from './Main';
global.$ = jquery;

const main = new Main(1024, 768);
main.init();
/* WebFont.load({
	custom: {
		families: ['Noto Kufi Arabic']
	},
	active: function() {
		main.init();
	}
});
 */
